import { render, staticRenderFns } from "./MealBookTurnScreen.vue?vue&type=template&id=7a666464&scoped=true&"
import script from "./MealBookTurnScreen.vue?vue&type=script&lang=ts&"
export * from "./MealBookTurnScreen.vue?vue&type=script&lang=ts&"
import style0 from "./MealBookTurnScreen.vue?vue&type=style&index=0&id=7a666464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a666464",
  null
  
)

export default component.exports